import { render, staticRenderFns } from "./StoreProductTab.vue?vue&type=template&id=c01d85bc&"
import script from "./StoreProductTab.vue?vue&type=script&lang=js&"
export * from "./StoreProductTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports